"use client";

import React, { useState } from "react";
import Image from "next/image";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Section from "../Section";
/*import "./Accordion.scss";*/
const styles = new Proxy({"Table":"Table-e2651","TableRow":"TableRow-e2651","TableSide":"TableSide-e2651","OnlyDesktop":"OnlyDesktop-e2651","OnlyMobile":"OnlyMobile-e2651","mobileRow":"mobileRow-e2651","Img":"Img-e2651","Grey":"Grey-e2651"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });

interface ListItem {
  list: { row: string }[];
  listTitle?: string;
  description?: never;
}

interface DescriptionItem {
  description: string;
  list?: never;
  listTitle?: never;
}

export type ResolvedAccordionItem = (ListItem | DescriptionItem) & {
  title: string;
  image: { url: string };
  eventKey: string;
  contentType: "description" | "list";
};

interface IconAccordionClientProps {
  items: ResolvedAccordionItem[];
}

const IconAccordionClient: React.FC<IconAccordionClientProps> = ({ items }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const toggleAccordion = (index: number) => {
    setActiveIndex(index);
  };

  return (
    <Section className="BiometricAccessControl">
      <div className="accordion py-5 only-desktop">
        {items.map((item, index) => (
          <div
            key={index}
            className={`accordion-item ${
              index === activeIndex ? "active" : ""
            }`}
            onClick={() => toggleAccordion(index)}
          >
            <div className="accordion-title">{item.title}</div>
            <div className="accordion-image">
              <Image
                src={item.image.url}
                alt="Illustration"
                width={168}
                height={168}
              />
            </div>
            <div className="accordion-content">
              <div className="container py-3">
                <div
                  className={`row mb-4 px-5 ${item.contentType === "list" ? "" : "text-center"}`}
                >
                  {item.contentType === "list" ? (
                    <>
                      {item.listTitle && <p>{item.listTitle}</p>}
                      <ul>
                        {item.list?.map((listItem, idx) => (
                          <li key={idx}>{listItem.row}</li>
                        ))}
                      </ul>
                    </>
                  ) : (
                    <p>{item.description}</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className={styles.OnlyMobile}>
        <div className="row mobile-table">
          <div className="col-12">
            <div className={styles.Table}>
              <Tabs defaultActiveKey="predictive">
                {items.map((item, idx) => (
                  <Tab key={idx} eventKey={item.eventKey} title={item.title}>
                    <div className={styles.mobileRow}>
                      <div className={styles.Img}>
                        <Image
                          src={item.image.url}
                          alt="Illustration"
                          width={168}
                          height={168}
                        />
                      </div>
                      {"list" in item ? (
                        <div>
                          {item.listTitle && <p>{item.listTitle}</p>}
                          <ul>
                            {item.list?.map((e, idx) => (
                              <li key={idx}>{e.row}</li>
                            ))}
                          </ul>
                        </div>
                      ) : (
                        <p>{item.description}</p>
                      )}
                    </div>
                  </Tab>
                ))}
              </Tabs>
            </div>
          </div>
        </div>
      </div>
    </Section>
  );
};

export default IconAccordionClient;
